import { render, staticRenderFns } from "./ViaGoogle.vue?vue&type=template&id=bc463616&scoped=true"
import script from "./ViaGoogle.vue?vue&type=script&lang=js"
export * from "./ViaGoogle.vue?vue&type=script&lang=js"
import style0 from "./ViaGoogle.vue?vue&type=style&index=0&id=bc463616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc463616",
  null
  
)

export default component.exports